export const POLICY_LABELS = {
  cancellation: 'Cancellation Policy',
  terms: 'Terms & Conditions',
  refund: 'Refund Policy',
  privacy: 'Privacy Policy',
  how_it_work: 'How it works',
};

export function isKnownPolicyType(type) {
  return Boolean(type && Object.prototype.hasOwnProperty.call(POLICY_LABELS, type));
}

export function mapPolicy(response, fallbackType) {
  const payload = response?.data?.policy || response?.data || {};

  return {
    title: payload.title || POLICY_LABELS[fallbackType] || 'Policy',
    content: payload.content || payload.body || payload.description || '',
    type: payload.type || payload.policy_type || fallbackType || '',
    updatedAt: payload.updated_at || payload.updatedAt || null,
  };
}

export function mapAboutUs(response) {
  const payload = response?.data?.about_us || response?.data || {};

  return {
    title: payload.title || 'About Us',
    content:
      payload.content ||
      payload.body ||
      payload.description ||
      payload.about ||
      '',
    updatedAt: payload.updated_at || payload.updatedAt || null,
  };
}
